import { render } from "./Main.vue?vue&type=template&id=9cd15d66"
const script = {}
script.render = render

export default script